export default __webpack_public_path__ + "static/media/mprnews.415c6739.svg";